import React from 'react';
import { useSelector } from 'react-redux';
import { authService } from '@app/services';
import { CompanyLogo, UserMenu, NotificationBell, HelpMenu } from '@app/components';
import { IGlobalState } from '@app/models';
import { ITCAppLauncher } from '@itglue/kaseya-ui';

interface IProps {
    kaseyaOneToken: string;
    setKaseyaOneToken: Function;
}

export const Navbar: React.SFC<IProps> = ({ kaseyaOneToken, setKaseyaOneToken }) => {
    const user = authService.getUserData();
    const appVersion = useSelector((state: IGlobalState) => state.basic.shellConfig.aaVersion);
    const domain = window.location.host;
    const regexp = /my.passly./g;
    const isQaEnv = !regexp.test(domain);

    return (
        <div className='main__navbar'>
            <div className='navbar'>
                <div className='navbar__content navbar__content--left'>
                    <CompanyLogo color='White' size='small' />
                </div>
                <div className='navbar__content navbar__content--right'>
                    <NotificationBell user={user} />
                    <HelpMenu appVersion={appVersion} />
                    <UserMenu user={user}  setKaseyaOneToken={setKaseyaOneToken} />
                    <ITCAppLauncher k1Token={kaseyaOneToken} isK1SsoSession={!!kaseyaOneToken} useQaLauncherApi={isQaEnv} launcherApiVersion={kaseyaOneToken ? 2 : 1} />
                </div>
            </div>
        </div>
    );
};
